<template>
	<div>
		<Row class="d-flex flex-wrap justify-content-center" :gutter="16">
			<Col :span="spanCount" v-for="(group, index) in groups" :key="index" class="mb-3">
				<Card class="table-card-style">
					<h2>{{ $t('competition.group') }} {{ index + 1 }}</h2>
					<table class="table table-bordered dt-responsive table-striped nowrap mt-3 match-table">
						<thead>
							<tr>
								<th>
									<span>{{ $t('competition.team_name') }}</span>
								</th>
								<th v-if="!isVisible" class="w-70px">
									<span>{{ $t('competition.points') }}</span>
								</th>
							</tr>
						</thead>
						<tbody class="w-100">
							<draggable v-if="isVisible" :disabled="!isVisible" :list="group" @change="() => blockSave()" group="teams">
								<tr v-for="team in group" :key="team._id" class="cursor inline-table w-100">
									<td>
										<Tooltip :content="team.name" placement="top-start">
											<span class="text-overflow-style groups-clamt-text">{{ team.name }}</span>
										</Tooltip>
									</td>
								</tr>
							</draggable>
							<tr v-else v-for="team in group" :key="team._id" class="cursor inline-table w-100 d-table-row">
								<td>
									<Tooltip :content="team.name" placement="top-start" class="w-100">
										<span class="text-overflow-style groups-clamt-text">{{ team.name }}</span>
									</Tooltip>
								</td>
								<td>
									<span v-if="team.statistics">{{ team.statistics.points }}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</Card>
			</Col>
		</Row>

		<Button v-if="isVisible" type="primary" long class="mb-3" style="font-size: 16px;"
			@click="() => generateRoundRobinSchedule(true)">
			<b>{{ $t('competition.generate') }}</b>
		</Button>
	</div>
</template>

<script>
import storeMixin from '../storeMixin';
import draggable from 'vuedraggable';

	export default {
		name: 'GroupsBlock',
		components: { draggable },
		data() {
			return storeMixin;
		},
		mounted() {
			this.getWidth();
			window.onresize = () => {
				this.getWidth();
			};
		},
	};
</script>

<style scoped>
.groups-clamt-text {
	width: 100%;
}

table {
	table-layout: fixed;
}

.w-70px {
	width: 70px;
	min-width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/groups/GroupsBlock.vue